/**
 * 国家枚举类型
 */
export enum Country {
    China = 'CHN',
    Indonesia = 'INA',
    Hongkong = 'HK',
}
